import * as ActionConfigurationManager from './config.actions';

export const loadPrismic = ActionConfigurationManager.LOAD_PRISMIC;
export const loadPrismicSuccess = ActionConfigurationManager.LOAD_PRISMIC_SUCCESS;
export const loadPrismicFailed = ActionConfigurationManager.LOAD_PRISMIC_FAILED;
export const resetPrismic = ActionConfigurationManager.RESET_PRISMIC;
